<template>
    <div>
        <label><b>{{field_anagrafica.type}}</b></label>
        <div>
            Nuovo anagrafica
            <input v-model="check_box" type="checkbox">
            <input v-if="check_box" class="form-control" v-model="field_anagrafica.nuova_anagrafica" :name="name_text" type="text" :required="required_new">
            <select v-if="!check_box" class="form-control" v-model="field_anagrafica.id_anagrafica" :name="name_id" autocomplete="on" :required="required_id">
                <option v-for="record in list" :value=record.id>{{record.nominativo}}</option>
            </select>
        </div>
    </div>
</template>
<script>
    export default {
        props:{
            anagrafica:{type:Object, required:true},
            name_id:{required:true},
            name_text:{required:true}
        },
        data(){
            let field_anagrafica    = this.anagrafica;
            let check_box           = false;
            let list                = [];
            let required_id         = true;
            let required_new        = false;

            return {
                field_anagrafica,
                check_box,
                list,
                error:null,
                message:null,
                loading:false,
                validForm:false,
                required_id,
                required_new
            };
        },
        mounted: function () {
            this.list = [];
            this.loadListAnagrafiche();
        },
        methods: {
            addFiles() {
                this.error = null;
            },
            loadListAnagrafiche() {
                this.errors = null;
                this.loading = true;
                axios.post('/clienti/all')
                .then((response) => {
                    if(response.data.result === "ok") {
                        this.list = response.data.list;
                    }
                })
                .catch((error) => {
                    this.errors = error;
                })
                .finally(() => {
                    this.loading = false
                });
            },
        },
        watch: {
            check_box() {
                this.field_anagrafica.nuova_anagrafica  = this.check_box ? this.field_anagrafica.nuova_anagrafica : "";
                this.field_anagrafica.id_anagrafica     = !this.check_box ? this.field_anagrafica.id_anagrafica : null;
                this.required_new   = (this.field_anagrafica.id_anagrafica == null) ? true : false;
                this.required_id    = (this.field_anagrafica.nuova_anagrafica == null || this.field_anagrafica.nuova_anagrafica == "") ? true : false;
            },
        }
    }
</script>
